import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout.vue';
import AuthLayout from '@/pages/Dashboard/Pages/AuthLayout.vue';

import Login from '@/pages/Dashboard/Pages/Login.vue';
import Register from '@/pages/Dashboard/Pages/Register.vue';

import Offers from '@/pages/Offers.vue';
import Job from '@/pages/Job.vue';
import LargeFormatJob from '@/pages/LargeFormatJob.vue';
import Inventory from '@/pages/Inventory.vue';
import Clients from '@/pages/Clients.vue';
import Invoices from '@/pages/Invoices.vue';
import OfferLogs from '@/pages/OfferLogs.vue';
import Expenses from '@/pages/Expenses.vue';
import Accounting from '@/pages/Accounting.vue';
import Transactions from '@/pages/Transactions.vue';
import Users from '@/pages/Users.vue';
import Materials from '@/pages/Materials.vue';

const authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Prijava',
      },
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
  ],
};

const routes = [
  {
    path: '/',
    redirect: '/files?filter=confirmed',
    name: 'Home',
  },
  authPages,
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: 'files',
        name: 'Kalkulacije',
        components: {
          default: Offers,
        },
        meta: {
          title: 'Kalkulacije',
        },
      },
      {
        path: 'job',
        name: 'Tabačna štampa',
        components: {
          default: Job,
        },
        meta: {
          title: 'Tabačna štampa',
        },
      },
      {
        path: 'large_format_job',
        name: 'Veliki formati i ostalo',
        components: {
          default: LargeFormatJob,
        },
        meta: {
          title: 'Veliki formati i ostalo',
        },
      },
      {
        path: 'clients',
        name: 'Klijenti',
        components: {
          default: Clients,
        },
        meta: {
          title: 'Klijenti',
        },
      },
      {
        path: 'inventory',
        name: 'Magacin',
        components: {
          default: Inventory,
        },
        meta: {
          title: 'Magacin',
        },
      },
      {
        path: 'invoices',
        name: 'Izlazne fakture',
        components: {
          default: Invoices,
        },
        meta: {
          title: 'Izlazne fakture',
        },
      },
      {
        path: 'offers',
        name: 'Ponude',
        components: {
          default: OfferLogs,
        },
        meta: {
          title: 'Ponude',
        },
      },
      {
        path: 'expenses',
        name: 'Ulazne fakture',
        components: {
          default: Expenses,
        },
        meta: {
          title: 'Ulazne fakture',
        },
      },
      {
        path: 'accounting',
        name: 'Računovodstvo',
        components: {
          default: Accounting,
        },
        meta: {
          title: 'Računovodstvo',
        },
      },
      {
        path: 'transactions',
        name: 'Transakcije',
        components: {
          default: Transactions,
        },
        meta: {
          title: 'Transakcije',
        },
      },
      {
        path: 'users',
        name: 'Korisnici',
        components: {
          default: Users,
        },
        meta: {
          title: 'Korisnici',
        },
      },
      {
        path: 'materials',
        name: 'Dodatne tabele',
        components: {
          default: Materials,
        },
        meta: {
          title: 'Dodatne tabele',
        },
      },
    ],
  },
];

export default routes;
